const PROVISION_ENABLE = {
  DISABILITY: false,
  ACCIDENT: false,
  PRESCRIPTIONS: false,
};

export default PROVISION_ENABLE;
